import { isDevHost } from '@/utils/host';
import router from '@/router';
import store from '@/store';

export const isUserAuthenticated = (): boolean => {
  const authToken = localStorage.getItem("token");
  return !!authToken;
}

export const userLogout = () => {
  localStorage.setItem('logout', '1');
  localStorage.removeItem('token');
  localStorage.removeItem('pharmId');
  localStorage.removeItem('pharmSkip');
  localStorage.removeItem('pharmSearch');
  localStorage.removeItem('activeNextMonth');
  localStorage.removeItem('activePrevMonth');
  isDevHost() ? router?.push(`/authentication-test`) : router?.push(`/authentication`);
  store.commit('clearDates');
  store.commit('data/setPharmSkip', 0);
  store.commit('data/setPharmSearchQuery', '');
}